

<template>
    <div>
        <div id="mynetwork" :class="{ 'collapsenetwork': !showingGraph }"></div>
        <button type="button" class="btn btn-warning" @click="refreshNodes" style="margin-left: 5px; margin-right: 5px;">
            <i class="fa fa-project-diagram"></i>
            Ver Relaciones
        </button>
    </div>
</template>
  

<style type="text/css">
#mynetwork {
    width: 100%;
    height: 400px;
    border: 1px solid lightgray;
}

.collapsenetwork {
    display: none;
}
</style>

<script>
import DynamicService from "@/services/commons/DynamicService";



export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        modulo: {
            type: String,
            required: true,
        },
        path: {
            type: String,
            required: true,
        },
    },
    components: {
    },
    data() {
        return {
            showingGraph: false
        };
    },
    watch: {
        id: function () {
        },
    },
    computed: {},
    mounted() {

    },
    created() {

    },
    methods: {
        refreshNodes() {
            let self = this;
            // create a network
            var container = document.getElementById("mynetwork");

            var options = {
                layout: {
                    hierarchical: {
                        enabled: true,
                        levelSeparation: 400,
                        direction: 'LR',
                        sortMethod: 'directed'
                    },
                },
                edges: {
                    scaling: {
                        min: 2,
                        max: 15,
                    },
                    width: 1,
                    length: 300
                },
                nodes: {
                    shape: "circle",
                    size: 500
                },
                physics: {
                    enabled: false,
                    repulsion: {
                        nodeDistance: 500,
                    },
                },
            };

            DynamicService.getAction(
                self.modulo, self.path, self.id, 'grafo_network', {}
            ).then((response) => {
                self.datos = response.data;


                var nodesData = [];
                var edgesData = [];

                self.showingGraph = !(self.showingGraph);
                self.datos.forEach(function (item, index) {

                    nodesData.push(item)
                    if (item.arrow_from != item.arrow_to) {
                        edgesData.push({
                            from: item.arrow_from,
                            to: item.arrow_to,
                            arrows: 'to'
                        });
                    }

                });

                var nodes = new vis.DataSet(nodesData);

                // create an array with edges
                var edges = new vis.DataSet(edgesData);

                var data = {
                    nodes: nodes,
                    edges: edges,
                };

                var network = new vis.Network(container, data, options);
                network.focus(self.id.replaceAll('-', ''))
                network.stabilize();

                network.on("doubleClick", function (params) {
                    params.event = "[original event]";
                    console.log(params)

                    if (params.nodes.length > 0) {

                        var selectedNode = params.nodes[0];
                        var result = self.datos.filter(obj => {
                            return obj.id === selectedNode
                        })
                        console.log(result)
                        if (result) {
                            window.location.href = result[0].url;
                        }
                    }
                });

            });

        }

    },
};
</script>
      
